<template>
  <slide-over-right :id="sorId" v-on:showModal="showModal" editType="standard">
    <loading :active.sync="isLoading"></loading>

    <template v-slot:header>
      <h2 class="font-semibold text-gray-900 text-22px">
        {{ getTitleText }}
      </h2>
    </template>

    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)" class="px-6">
        <AppInput
          v-model="form.title"
          type="text"
          rules="required"
          :name="
            $t(
              'components.settingsManagement.riderApp.bannerMessages.addEdit.title.title'
            )
          "
          :label="
            $t(
              'components.settingsManagement.riderApp.bannerMessages.addEdit.title.title'
            )
          "
        />
        <AppInput
          v-model="form.description"
          type="textarea"
          rules="required"
          :name="
            $t(
              'components.settingsManagement.riderApp.bannerMessages.addEdit.title.description'
            )
          "
          :label="
            $t(
              'components.settingsManagement.riderApp.bannerMessages.addEdit.title.description'
            )
          "
        />
        <div>
          <label class="font-semibold leading-normal text-14px text-gray-700"
            >{{
              $t(
                'components.settingsManagement.riderApp.bannerMessages.addEdit.title.icon'
              )
            }}
          </label>
          <UploadAvatar
            v-model="form.icon"
            :current="form.icon"
            :class="`mb-3`"
          />
        </div>

        <div class="flex justify-end items-center mt-6">
          <slide-over-right-trigger :id="sorId">
            <anchor-button variant="secondary">{{
              $t('components.stepNavigation.cancel')
            }}</anchor-button>
          </slide-over-right-trigger>
          <t-button type="submit" class="ml-3">{{
            isEditing
              ? $t('components.stepNavigation.update')
              : $t('components.stepNavigation.save')
          }}</t-button>
        </div>
      </form>
    </ValidationObserver>
  </slide-over-right>
</template>

<script>
import xMan from '@/utils/xMan'
import { EventBus } from '@/utils/EventBus'
import { BannerMessageConfig } from '@/config/BannerMessageConfig'
import { UploadAvatar } from '@/components/form'
export default {
  name: 'AddEditBannerMessage',
  props: {
    messageTypes: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    SlideOverRight: () => import('@/components/modals/SlideOverRight'),
    SlideOverRightTrigger: () =>
      import('@/components/modals/SlideOverRightTrigger'),
    AnchorButton: () => import('@/components/form/AnchorButton.vue'),
    UploadAvatar,
  },
  data() {
    return {
      isLoading: false,
      item: {},
      form: {},
      errors: [],
      sorId: BannerMessageConfig.events.sorId,
    }
  },
  computed: {
    isEditing: function() {
      return Object.keys(this.item).length !== 0
    },
    getTitleText() {
      return this.isEditing
        ? this.$t(
            'components.settingsManagement.riderApp.bannerMessages.addEdit.headline.edit'
          )
        : this.$t(
            'components.settingsManagement.riderApp.bannerMessages.addEdit.headline.add'
          )
    },
  },
  mounted() {
    EventBus.$on(BannerMessageConfig.events.editingData, (item) => {
      this.item = item
      this.form = { ...this.item }
    })
  },
  methods: {
    showModal() {
      dispatchEvent(new Event(BannerMessageConfig.events.sorToggle))
    },
    submit: async function() {
      this.isLoading = true
      let method = this.isEditing ? 'PATCH' : 'POST'
      let url = this.isEditing
        ? BannerMessageConfig.api.update(this.item.id)
        : BannerMessageConfig.api.create()

      const formDataProxy = { ...this.form }
      if (this.isEditing) {
        delete formDataProxy.id
      }
      if (
        typeof formDataProxy.icon === 'string' ||
        formDataProxy.icon == null
      ) {
        delete formDataProxy.icon
      }

      let data = new xMan(formDataProxy).toFormData()
      let message = this.isEditing
        ? 'Banner updated successfully'
        : 'Banner added successfully'

      try {
        let response = await this.$http({ method, url, data })
        this.isLoading = false
        // Close the slideover
        dispatchEvent(new Event(BannerMessageConfig.events.sorClose))
        // Refetch the indexData
        dispatchEvent(new Event(BannerMessageConfig.events.refresh))
        // Reset the form
        this.form = {}
        this.$notify(
          {
            group: 'generic',
            type: 'success',
            title: 'Success',
            text: message,
          },
          3000
        )
        // Resolved
        return response.status
      } catch (error) {
        this.isLoading = false

        console.log('banner-add-edit-err', { error })

        this.$notify(
          {
            group: 'generic',
            type: 'error',
            title: `Failed [${error.response.status}]`,
            text:
              error.response.status >= 500
                ? 'Failed to delete'
                : error.response.data.message,
          },
          3000
        )
      }
    },
  },
}
</script>

<style></style>
